import { render } from "./AHeader.vue?vue&type=template&id=37155cbd"
import script from "./AHeader.vue?vue&type=script&lang=js"
export * from "./AHeader.vue?vue&type=script&lang=js"

import "./AHeader.vue?vue&type=style&index=0&id=37155cbd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__